function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import './ticker.scss';
/* import LogoA3Elecciones from './../../assets/logo_a3_elecciones_2019.svg'; */

import LogoA3Elecciones26M from "./../../assets/logo_elecciones26m.svg";
import { Fragment } from 'react';
const ANIMATION_TIME = 70;
export const Ticker = ({
  congressAndSenateResults
}) => {
  const senate = congressAndSenateResults.senate,
        congress = congressAndSenateResults.congress;

  const _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        leftPosition = _useState2[0],
        setLeftPosition = _useState2[1];

  const tickerTextElementRef = useRef();
  const style = useMemo(() => ({
    left: "".concat(-leftPosition, "px"),
    transition: "left ".concat(leftPosition / ANIMATION_TIME, "s linear")
  }), [leftPosition]);
  useEffect(() => {
    setLeftPosition(tickerTextElementRef.current.getBoundingClientRect().width);
  });
  const data = [{
    type: 'CONGRESO',
    partiesResult: congress.partiesResult
  }, {
    type: 'SENADO',
    partiesResult: senate.partiesResult
  }];
  return React.createElement(Fragment, null, React.createElement("div", {
    className: "ticker_container font-isidora"
  }, React.createElement("div", {
    className: "ticker"
  }, React.createElement("div", {
    className: "ticker_logo"
  }, React.createElement("img", {
    src: LogoA3Elecciones26M,
    alt: "Logo de Antena3 Elecciones",
    title: "A3 Elecciones"
  })), React.createElement("div", {
    className: "ticker_content"
  }, React.createElement("div", {
    className: "ticker_text",
    ref: tickerTextElementRef,
    style: style
  }, congress.partiesResult && senate.partiesResult && data.map(item => {
    return React.createElement(Fragment, {
      key: item.type
    }, React.createElement("span", {
      className: "province_name"
    }, "".concat(item.type, " ")), React.createElement("span", {
      className: "province_separator"
    }, "|"), " ", item.partiesResult.filter(item => item.seats).map(result => {
      return React.createElement("span", {
        key: "".concat(result.partyAcronym, "-").concat(item.type),
        className: "province_percent"
      }, result.partyAcronym, " : ", result.seats, " esc.", " | ");
    }));
  }))), React.createElement("div", {
    className: "ticker_hashtag"
  }, React.createElement("a", {
    href: "https://twitter.com/hashtag/EleccionesA3N?f=tweets",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "#EleccionesA3N")))));
};
export default Ticker;